import { render } from "./EmailsView.vue?vue&type=template&id=5b2aeff7&scoped=true&ts=true"
import script from "./EmailsView.vue?vue&type=script&lang=ts"
export * from "./EmailsView.vue?vue&type=script&lang=ts"

import "./EmailsView.vue?vue&type=style&index=0&id=5b2aeff7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2aeff7"]])

export default __exports__